import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/locationCounts'
import Component from 'components/LocationCounts'

export default createListViewContainer({ actions, selectors: selectors.locationCounts })(Component)
